var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, useURLState } from '@parca/components';
import useUIFeatureFlag from '@parca/functions/useUIFeatureFlag';
var ViewSelector = function (_a) {
    var defaultValue = _a.defaultValue, navigateTo = _a.navigateTo, position = _a.position, placeholderText = _a.placeholderText, _b = _a.primary, primary = _b === void 0 ? false : _b, _c = _a.addView, addView = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var callgraphEnabled = useUIFeatureFlag('callgraph')[0];
    var _e = useURLState({
        param: 'dashboard_items',
        navigateTo: navigateTo,
    }), dashboardItems = _e[0], setDashboardItems = _e[1];
    var allItems = [
        { key: 'table', canBeSelected: !dashboardItems.includes('table') },
        { key: 'icicle', canBeSelected: !dashboardItems.includes('icicle') },
    ];
    if (callgraphEnabled) {
        allItems.push({
            key: 'callgraph',
            canBeSelected: !dashboardItems.includes('callgraph'),
        });
    }
    var getOption = function (_a) {
        var key = _a.key, supportingText = _a.supportingText;
        var capitalizeFirstLetter = function (string) {
            return "".concat(string.charAt(0).toUpperCase()).concat(string.slice(1));
        };
        var title = capitalizeFirstLetter(key);
        return {
            active: _jsx(_Fragment, { children: title }),
            expanded: (_jsxs(_Fragment, { children: [_jsx("span", { children: title }), supportingText !== null && _jsx("span", __assign({ className: "text-xs" }, { children: supportingText }))] })),
        };
    };
    var items = allItems.map(function (item) { return ({
        key: item.key,
        disabled: !item.canBeSelected,
        element: getOption(item),
    }); });
    var onSelection = function (value) {
        if (addView) {
            setDashboardItems([dashboardItems[0], value]);
            return;
        }
        var isOnlyChart = dashboardItems.length === 1;
        if (isOnlyChart) {
            setDashboardItems([value]);
            return;
        }
        // Note: this will need to be updated if we ever have more more than 2 panels
        var isFirstChart = position === 0;
        var newDashboardItems = isFirstChart
            ? [value, dashboardItems[1]]
            : [dashboardItems[0], value];
        setDashboardItems(newDashboardItems);
    };
    return (_jsx(Select, { items: items, selectedKey: defaultValue, onSelection: onSelection, placeholder: placeholderText !== null && placeholderText !== void 0 ? placeholderText : 'Select view type...', primary: primary, disabled: disabled }));
};
export default ViewSelector;
